import { render, staticRenderFns } from "./CreateCompany.vue?vue&type=template&id=992b10e8&scoped=true&"
import script from "./CreateCompany.vue?vue&type=script&lang=js&"
export * from "./CreateCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992b10e8",
  null
  
)

export default component.exports